<script setup>
defineProps({
  to: {
    type: String,
    default: undefined,
  },
  target: {
    type: String,
    default: undefined,
  },
  href: {
    type: String,
    default: undefined,
  },
  download: {
    type: [Boolean, String],
    default: false,
  },
  theme: {
    type: String,
    default: 'primary',
    validator(value) {
      return [
        'primary',
        'secondary',
        'secondary-dark',
        'secondary-dark-alt',
        'secondary-transparent',
        'black',
        'transparent',
        'purple',
        'purple-outlined',
        'purple-outlined-2',
        'outlined-transparent',
      ].includes(value);
    },
  },
  text: {
    type: String,
    default: undefined,
  },

  isStaticByDefault: {
    type: Boolean,
    default: false,
  },
  staticTag: {
    type: String,
    default: undefined,
  },

  isLoading: {
    type: Boolean,
    default: false,
  },

  type: {
    type: String,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

function emitClick() {
  emit('click');
}
</script>

<template>
  <CTagDetect
    class="ui-button"
    :class="`ui-button--theme--${theme}`"
    :to="to"
    :href="href"
    :target="target"
    :type="type"
    :disabled="disabled || isLoading"
    @click="emitClick"
  >
    <div class="ui-button__container">
      <slot name="icon-left" />

      <slot>
        <span class="ui-button__font">
          {{ text }}
        </span>
      </slot>

      <slot name="icon-right" />

      <div v-show="isLoading" class="ui-button__loader" />
    </div>
  </CTagDetect>
</template>
